import React, { useState, useEffect } from 'react'
//import products from '../products'

const ShowPdfScreen = () => {
  const docid = sessionStorage.getItem('docid')
  window.location.replace("/api/file/showpdf/" + docid)
}

export default ShowPdfScreen